import GenericGallery from "./GenericGallery";
import { panelData } from "./Config";

const Panel_client = () => (
  <GenericGallery 
    galleryData={panelData} // Array de proyectos
    galleryType="paneles"
    baseRoute="/galeria-paneles"
  />
);

export default Panel_client;